export default __webpack_public_path__ + "static/media/75.46f9713f.jpg";